import { 
  Button,
  Icon,
  IconButton,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  Input 
} from '@chakra-ui/react';
import Select from 'react-select';
import { RangeDatepicker } from "chakra-dayzed-datepicker";
import { MdLogout } from 'react-icons/md'

function SearchControls({ 
  channelFilter,
  setChannelFilter,
  selectedDates,
  setSelectedDates,
  fetchDynamoRecords,
  signOut,
  agentFilter,
  setAgentFilter,
  queueFilter,
  setQueueFilter,
  phoneFilter,
  setPhoneFilter,
  subjectFilter,
  setSubjectFilter,
  emailFilter,
  setEmailFilter,

}) {
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '40%'
    })
  };
  return (
    <Flex flexDirection='column' height='5%' width='100%' mt='10px'>
      <Flex flexDirection='row' justifyContent='space-between' width='100%'>
              <Select
                // isMulti
                name='mediaTypes'
                placeholder="Choose a media type"
                defaultValue={channelFilter}
                options={[{value: 'WEBCHAT', label: 'Chat'}, {value: 'EMAIL', label: 'Email'}, {value: 'VOICE', label: 'Voice'}, {value: 'SMS', label: 'SMS'}, {value: 'TASK', label: 'Task'}]}
                // className='basic-multi-select'
                // classNamePrefix='select'
                onChange={(e => setChannelFilter([e]))}
                styles={customStyles}
           
              />
              <RangeDatepicker
                selectedDates={selectedDates}
                onDateChange={setSelectedDates}
                configs={{
                  dateFormat: 'dd-MM-yyyy',
                }}
                propsConfigs={{
                  inputProps: {
                    width:'40%'
                  },
                  dayOfMonthBtnProps: {
                    defaultBtnProps: {
                      borderColor: "red.300",
                      _hover: {
                        background: 'green.500',
                        color: 'white'
                      }
                    },
                    selectedBtnProps: {
                      background: "green.400",
                      color: "white",
                    },
                    isInRangeBtnProps: {
                      background: 'green.200',
                        color: 'black'
                    },
                  }
                }}
              />
              
              <Button colorScheme='green' onClick={fetchDynamoRecords}> Search</Button>
              <IconButton
                variant='outline'
                colorScheme='red'
                aria-label='log out'
                size='md'
                icon={<Icon boxSize={7} as={MdLogout}/>}
                onClick={signOut}
                style={{marginLeft: '5vw'}}
              />
      </Flex>
        <Accordion  mt='10px' allowToggle>
          <AccordionItem>
            <h2>
              <AccordionButton>
                <Box as="span" flex='1' textAlign='left'>
                  Filters
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
                <Flex flexDirection='row' justifyContent='space-evenly' width='100%'>
                  <Input 
                    ml='10px' 
                    placeholder='Customer Email Address'
                    value={emailFilter}
                    onChange={(e) => setEmailFilter(e.target.value)} 
                  
                  />
                  <Input 
                    ml='10px' 
                    placeholder='Email Subject'
                    value={subjectFilter}
                    onChange={(e) => setSubjectFilter(e.target.value)} 
                  
                  />
                  <Input 
                    ml='10px' 
                    placeholder='Customer Phone Number'
                    value={phoneFilter}
                    onChange={(e) => setPhoneFilter(e.target.value)} 
                  
                  />
                  <Input 
                    ml='10px' 
                    placeholder='Agent Name'
                    value={agentFilter}
                    onChange={(e) => setAgentFilter(e.target.value)} 
                  
                  />
                  <Input 
                    ml='10px' 
                    placeholder='Queue Name'
                    value={queueFilter}
                    onChange={(e) => setQueueFilter(e.target.value)} 
                  
                  />
                </Flex>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
    </Flex>
    
  );
}

export default SearchControls;
